import { Switch } from "antd";
import React from "react";

import { ReactComponent as Check } from "./checked.svg";
import { ReactComponent as Cross } from "./cross.svg";

// @ts-ignore
import styles from "./styles.module.scss";

const CustomSwitch = ({
  checked,
  onChange,
  disabled,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled: boolean;
}) => {
  return (
    <div
      className={`${styles.switch} ${
        checked ? styles.switchActive : styles.switchInactive
      }`}
    >
      <h3 className={styles.switchTitle}>{checked ? "Active" : "Inactive"}</h3>
      <div className={styles.switchContent}>
        <Switch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          aria-label={checked ? "Deactivate category" : "Activate category"}
        />
        <span>{checked ? <Check /> : <Cross />}</span>
      </div>
    </div>
  );
};

export default CustomSwitch;
